<template>
    <div class="hero">
        <div class="hero-content">
            <CdnImage 
                classes="hero-logo" 
                src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/logo"
                fallbackSrc="./static/assets/logo.png" 
                alt="Veszprém és környéke - Redőnyjavítás"/>
        </div>
    </div>
</template>

<script>
import CdnImage from './CdnImage.vue';

export default {
    name: 'HeroContainer',
    props: {
        backHeight: Number,
    },
    components: {
        CdnImage,
    }
}
</script>

<style scoped>
.hero {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.hero::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/hero-bg);
    background-repeat: no-repeat;
    background-position: center bottom 25%;
    filter: brightness(85%);
    background-attachment: fixed;
    background-size: cover;
}

@media screen and (max-width: 800px) {
    .hero {
        background: url(https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/hero-bg-phone);
        background-size: cover;
    }

    .hero::before {
        background: none !important;
    }

    .hero-logo {
        width: 300px !important;
        height: 300px !important;
    }

    .hero-content {
        position: relative;
        left: 0% !important;
    }
}

.hero-content {
    position: relative;
    left: 25%;
}

.hero-logo {
    height: 450px;
}
</style>
